import { icons, IconText } from '../../../generic';
import type { Repository } from '../../../../types';

import ProjectRowBase from './ProjectRowBase';
import type { OnBranchChangeFn, OnImportRepositoryFn, OnSelectRepositoryFn } from './types';

import styles from './EmptyProjectRow.module.less';

type EmptyProjectRowProps = {
  repo: Repository;
  selectedRepos: Repository[];
  onBranchChange: OnBranchChangeFn;
  onSelectRepository: OnSelectRepositoryFn;
  onImportRepository: OnImportRepositoryFn;
};

const EmptyProjectRow = ({
  repo,
  selectedRepos,
  onBranchChange,
  onSelectRepository,
  onImportRepository,
}: EmptyProjectRowProps) => {
  const status = (
    <span className={styles.emptyWarning}>
      <IconText icon={icons.warning} text="This repo is empty and has no commits to analyze." marginAmount="8px" />
    </span>
  );

  return (
    <ProjectRowBase
      repo={repo}
      selectedRepos={selectedRepos}
      onBranchChange={onBranchChange}
      onSelectRepository={onSelectRepository}
      onImportRepository={onImportRepository}
      status={status}
      rowClassName={styles.row}
      isDisabled
    />
  );
};

export default EmptyProjectRow;
